import { useState, useCallback, useMemo } from 'react';

export const useNotification = () => {
  const [notifications, setNotifications] = useState([]);

  const showNotification = useCallback((message, type = 'success', duration = 3000) => {
    const id = Date.now();
    setNotifications(prev => [...prev, { id, message, type, duration }]);
  }, []);

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  }, []);

  // Use useMemo to ensure the returned object is stable
  const api = useMemo(() => ({
    notifications,
    showNotification,
    removeNotification,
    success: (message, duration) => showNotification(message, 'success', duration),
    error: (message, duration) => showNotification(message, 'error', duration),
    info: (message, duration) => showNotification(message, 'info', duration),
    warning: (message, duration) => showNotification(message, 'warning', duration)
  }), [notifications, showNotification, removeNotification]);

  return api;
};
